export enum WalletMfaMethod {
  Totp = 'totp',
}

export enum WalletMfaErrorKind {
  InvalidCode = 'invalid-code',
  Timeout = 'timeout',
  MaxAttempts = 'max-attempts',
  Unknown = 'unknown',
}

export enum WalletMfaVerificationPhase {
  Closed = 'closed',
  TotpStarting = 'totp-starting',
  Totp = 'totp',
  TotpSubmitting = 'totp-submitting',
  Error = 'error',
}

export enum WalletMfaVerificationPurpose {
  Transaction = 'transaction',
  SecurityChange = 'security-change',
}

export type WalletMfaError = {
  kind: WalletMfaErrorKind;
  message: string;
};

export type WalletTotpEnrollmentMaterial = {
  sharedSecret: string;
  setupUri: string;
};
